import React from 'react';
import {
  Tabs as MuiTabs,
  Tab,
  TabsProps as MuiTabsProps,
  Box,
} from '@mui/material';
import { StyledTabs, StyledTab, TabPanel } from './Tabs.style';

export interface TabData {
  label: string;
  value: string;
  disabled?: boolean;
  icon?: React.ReactElement;
  content?: React.ReactNode;
}

export interface TabsProps extends Omit<MuiTabsProps, 'onChange'> {
  /**
   * Array of tabs
   */
  tabs: TabData[];
  /**
   * The currently selected tab value
   */
  value: string;
  /**
   * Callback fired when tab changes
   */
  onChange: (value: string) => void;
  /**
   * The variant of the tabs
   */
  variant?: 'standard' | 'scrollable' | 'fullWidth';
  /**
   * The orientation of the tabs
   */
  orientation?: 'horizontal' | 'vertical';
  /**
   * Whether to show tab panels
   */
  showPanels?: boolean;
}

export const Tabs: React.FC<TabsProps> = ({
  tabs,
  value,
  onChange,
  variant = 'standard',
  orientation = 'horizontal',
  showPanels = true,
  ...props
}) => {
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    onChange(newValue);
  };

  return (
    <Box>
      <StyledTabs
        value={value}
        onChange={handleChange}
        variant={variant}
        orientation={orientation}
        {...props}
      >
        {tabs.map((tab) => (
          <StyledTab
            key={tab.value}
            label={tab.label}
            value={tab.value}
            disabled={tab.disabled}
            icon={tab.icon}
            iconPosition="start"
          />
        ))}
      </StyledTabs>
      
      {showPanels && tabs.map((tab) => (
        <TabPanel key={tab.value} value={value} index={tab.value}>
          {tab.content}
        </TabPanel>
      ))}
    </Box>
  );
}; 